var _g, _line, _line2, _line3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 85,
    viewBox: "0 0 69 85",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5155 28.0847C59.1364 27.5439 58.4943 27.3003 57.8658 27.3936C57.8419 27.3879 57.818 27.3777 57.7941 27.3743L32.0585 23.5968C31.7773 23.5546 31.4904 23.5854 31.2229 23.6833L10.6105 31.2383C10.6014 31.2417 10.5934 31.2474 10.5843 31.2508C10.5627 31.26 10.5422 31.2736 10.5194 31.2816C10.4067 31.3317 10.302 31.3909 10.2052 31.4603C10.1756 31.482 10.1471 31.5036 10.1175 31.5275C10.0117 31.614 9.9149 31.7085 9.83406 31.8167C9.82951 31.8235 9.82268 31.8269 9.81812 31.8338L1.11436 43.7401C0.780787 44.1966 0.694262 44.7909 0.88439 45.3237C1.07452 45.8577 1.51739 46.2607 2.06614 46.4019L9.61889 48.3521V67.0245C9.61889 67.7748 10.1096 68.4385 10.828 68.6582L38.4819 77.1081C38.491 77.1127 38.5013 77.1092 38.5104 77.1138C38.6584 77.1548 38.8132 77.181 38.968 77.1821C38.9714 77.1821 38.976 77.1844 38.9806 77.1844H38.9817C39.1445 77.1844 39.3039 77.1548 39.4633 77.1081C39.5134 77.0922 39.5601 77.0705 39.6113 77.0489C39.6785 77.0238 39.7445 77.0056 39.8105 76.9715L59.6544 65.9589C60.1975 65.6572 60.5333 65.0856 60.5333 64.4652V45.7962L67.2459 42.5743C67.6978 42.358 68.0314 41.9515 68.1589 41.4665C68.2853 40.9804 68.1931 40.4646 67.9051 40.0537L59.5155 28.0847ZM31.9914 27.0396L52.0789 29.9883L38.754 36.1839L17.6532 32.296L31.9914 27.0396ZM11.9437 34.7164L36.1218 39.1725L29.0153 49.8333L5.35752 43.7253L11.9437 34.7164ZM13.0344 65.7608V49.2333L29.3353 53.4423C29.4776 53.4776 29.6199 53.4969 29.7622 53.4969C30.3235 53.4969 30.8608 53.2192 31.183 52.7364L37.2728 43.6023V73.1666L13.0344 65.7608ZM57.1167 63.4587L40.6872 72.5746V45.6004L43.6871 51.9748C43.8818 52.3858 44.2324 52.7046 44.6593 52.8548C44.8449 52.9231 45.0385 52.9539 45.2309 52.9539C45.4848 52.9539 45.7364 52.897 45.9697 52.7877L57.1144 47.439L57.1167 63.4587ZM46.046 48.9635L41.2564 38.7877L57.5391 31.2167L63.9533 40.3667L46.046 48.9635Z",
    fill: "#189adc"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 35.1895,
    y1: 17.7939,
    x2: 35.1895,
    y2: 2.40412,
    stroke: "#189adc",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.4316,
    y1: 15.1667,
    x2: 25.4316,
    y2: 5.03115,
    stroke: "#189adc",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 44.9453,
    y1: 15.1667,
    x2: 44.9453,
    y2: 5.03115,
    stroke: "#189adc",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.4294,
    height: 67.4294,
    fill: "white",
    transform: "translate(0.785156 16.6667)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.0cafacaa23b01722cf969ccfb6bbf53c.svg";
export { ForwardRef as ReactComponent };